import React, { useContext } from "react";

import HeatingButton from "./HeatingButton";
import HotWaterButton from "./HotWaterButton";
import AwayButton from "./AwayButton";
import PriceButton from "./PriceButton";
import { AuthContext } from "../../AuthProvider";
import ControlPanelButton from "./ControlPanelButton";
import { ScreenContext } from "../../ScreenProvider";
import OperationalStatus from "../esp/OperationalStatus";

const ControlPanelMenu = () => {

    const { esp } = useContext(AuthContext)
    const { isMobile } = useContext(ScreenContext)

    return (
        <>
            {esp && (
                <div>
                    {esp.sensorData?.heatpumpNotWorkingWarning && (
                        <div className="bg-warning m-2 mb-3 heatpump-warning">
                            <div className="d-flex align-items-center">
                                <i className="bi bi-exclamation-triangle m-2 text-dark"></i>
                                <span className="text-dark">
                                    <strong>Varning:</strong> Inomhustemperaturen har fallit med minst 1°C under de senaste 2 timmarna trots aktiv uppvärmning. Kontrollera att värmepumpen är igång och fungerar korrekt.
                                </span>
                            </div>
                        </div>
                    )}
                    <div style={{ 
                        display: 'flex', 
                        flexDirection: 'row',
                        justifyContent: isMobile ? 'flex-start' : 'space-between', 
                        alignItems: isMobile ? 'center' : 'center', 
                        flexWrap: isMobile ? 'wrap' : 'nowrap', 
                        gap: isMobile ? '6px' : '0',
                        width: '100%',
                    }}>
                        <div style={{ display: 'flex', flexWrap: 'wrap', alignItems: 'center', gap: isMobile ? '0' : '0' }}>
                            <ControlPanelButton />
                            <HeatingButton />
                            <HotWaterButton />
                            <PriceButton />
                            {/*<WeatherButton />*/}
                            {isMobile && <AwayButton />}
                            {isMobile && (
                                <div style={{ 
                                    display: 'flex', 
                                    alignItems: 'center',
                                    flexShrink: 0,
                                    marginLeft: '6px',
                                    zIndex: 10,
                                    position: 'relative',
                                }}>
                                    <OperationalStatus />
                                </div>
                            )}
                        </div>
                        {!isMobile && <AwayButton style={{ marginLeft: 'auto' }} />}
                    </div>
                </div>)}
        </>
    );
};

export default ControlPanelMenu;